import { A48ActivityType } from "../enum/a48-activity-type.enum";
import { A48SubmissionContextCode } from "../enum/a48-submission-context-code.enum";

export class CplA48UserSubmissionDetail {
    PPID: string;
    UserId: string;
    TypeId: string;
    Type: number;
    ItemId: string;
    ItemType: number;
    Hours: number;
    UserDate: string;
    SubmissionID: string;
    StatusID: number;
    Status: string;
    ParaStatusID: number;
    ParaApplicable: number;
    EventName: string;
    EventStart: Date;
    EventEnd: Date;
    CourseType: number;
    Provider: string;
    AUN: string;
    ActivityType:A48ActivityType;
    CollegeCreditType: number;
    CECPerformanceStandard: number;
    UserDisplayName: string;
    Confirm: boolean;
    IsFollowup:boolean;
    IsPara:boolean;
    SubmissionTimeStamp: Date;
    ShouldSubmitToPerms: boolean;
    ContextCode: A48SubmissionContextCode;
}